import type { WebUiAccessError } from './switch-access';

function messageFor(error: WebUiAccessError): string {
  if ('kind' in error) {
    return 'The URL must include a device id (e.g. open details from the topology editor).';
  }
  if (error.reason === 'not_found') {
    return 'This device was not found in the saved project.';
  }
  return 'Only managed switches (or devices) can open this interface.';
}

export default function WebUiAccessDenied({
  error,
}: {
  error: WebUiAccessError;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-webui-bg px-4 font-webui text-webui-text">
      <p className="max-w-md text-center text-sm">{messageFor(error)}</p>
      <a className="text-sm font-bold text-webui-primary underline" href="/">
        Back to topology
      </a>
    </div>
  );
}
